export default __webpack_public_path__ + "static/Plots0072-fd7ab09e3f9b4a60223c5d37974d0a3d.jpg";